export enum FeatureFlag {
  /* Maintenance and Triggers */
  HealthCheckCron = 'health-check-cron',
  /**
   * Shows the health-check board's "Run all checks" button. Every admin can
   * read the board and re-run a single check; a full sweep is ~120 probes over
   * several minutes and spends a metered contact-enrichment call, so it is
   * targeted at the engineering team rather than every admin.
   */
  HealthCheckRunAll = 'health-check-run-all',
  Maintenance = 'maintenance',
  Refresh = 'force-refresh',
  Logout = 'force-logout',

  /* Feature Flags */
  // Activity as a secondary filter on Company pages: any page whose primary
  // filter is Company (`/company/*`). Every other page carries the filter
  // whatever this says — see FilterProvider.
  ActivityTaxonomyCompany = 'activity-taxonomy-company',
  CompanyDiscoveryValuationFilter = 'company-discovery-valuation-filter',
  DiversityQuery = 'diversity-query',
  // Kill switch (NOT an enable gate): absent/off means the AI assistant
  // behaves normally. Targeted per client via an Unleash constraint on the
  // `client` context property, for customers whose internal policy forbids
  // sending prompts to an LLM vendor. Deliberately inverted vs. every other
  // flag here so an Unleash outage leaves the assistant working rather than
  // silently removing it for everyone — see #6145, which retired the
  // enable-style GlobalAiAssistant flag.
  DisableAIAssistant = 'disable-ai-assistant',
  CustomReportNewLayout = 'custom-report-new-layout',
  CustomReports = 'custom-reports',
  CustomReportsSnowflake = 'custom-reports-snowflake',
  ExperimentalReports = 'experimental-reports',
  EconomicImpactNewLayoutApp = 'economic-impact-new-layout-app',
  PPTPreview = 'ppt-preview',
  PromoteMarketConditionsReportTemplate = 'promote-market-conditions-report-template',
  PromoteOrgHealthReportTemplate = 'promote-org-health-report-template',
  SelectionListIds = 'enable-selection-list-ids',
  SharedReports = 'shared-reports',
  // Backend testing aid: account-menu override for composition_v3 `*_top_n`.
  CompositionTopNOverride = 'composition-top-n-override',
  CompositionV4 = 'composition-v4',
}
